export const SortPriorityOrder = {
  MandatoryOngoing: 1,
  RecommendOngoing: 2,
  MandatoryNotStarted: 3,
  RecommendNotStarted: 4,
  MandatoryCompleted: 5,
  RecommendCompleted: 6,
};
